export class DLZData {
  constructor(
    public readonly materialCoverageMaxThreshold: string | null,
    public readonly dlzMaxTimeMinutes: number | null,
    public readonly modifiedAt: string,
    public readonly modifiedBy: string
  ) {}
}
